var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"collapse-list"},[_c('div',{staticClass:"pr-2",staticStyle:{"max-height":"calc(100vh - 173px)","overflow":"auto"}},[_c('el-row',[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }